import { styled } from 'styled-components';
import bg from '../../assets/images/specs_bg.png';

interface IProgressValue extends React.HTMLAttributes<HTMLDivElement> {
	$value: number;
	$maxValue: number;
}

const StyledContainer = styled.div`
	position: relative;
	display: flex;
	align-items: flex-end;
	gap: 10px;
	user-select: none;
	padding: 20px 10px 20px 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border-radius: 5px;
	background-image: url(${bg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
`;

const StyledIcon = styled.div<{
	$src: string;
}>`
	position: relative;
	width: 40px;
	min-width: 40px;
	height: 40px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.05);

	&::before {
		content: '';
		position: absolute;
		width: 100%;
		height: 100%;
		mask-image: url(${(props) => props.$src});
		mask-size: 20px 20px;
		mask-position: center;
		mask-repeat: no-repeat;
		-webkit-mask-image: url(${(props) => props.$src});
		-webkit-mask-size: 20px 20px;
		-webkit-mask-position: center;
		-webkit-mask-repeat: no-repeat;
		background-color: #ffffff;
	}
`;

const StyledContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
	width: 100%;
`;

const StyledLabelsContainer = styled.div`
	display: flex;
	justify-content: space-between;

	> span {
		color: #000000bf;
	}

	.name,
	.value,
	.measure {
		font-family: 'GT Walsheim Pro';
		font-size: 14px;
	}

	.name {
		color: rgba(255, 255, 255, 0.5);
		margin-right: auto;
	}

	.value {
		color: #ffffff;
		font-weight: bold;
	}

	.measure {
		color: rgba(255, 255, 255, 0.25);
	}

	/* div:last-child {
		display: flex;
		flex-direction: row;
	} */
`;

const StyledProgressValue = styled.div<IProgressValue>`
	position: relative;
	width: 100%;
	height: 20px;
	border-radius: 4px;
	background-color: rgba(255, 255, 255, 0.05);

	&::after {
		content: '';
		position: absolute;
		width: ${({ $value, $maxValue }) => Math.min($value / $maxValue, 1) * 100}%;
		height: 100%;
		border-radius: 5px;
		background-color: #ffffff;
		transition: width 0.25s ease;
	}
`;

export {
	StyledContainer,
	StyledContentContainer,
	StyledIcon,
	StyledLabelsContainer,
	StyledProgressValue,
};
